import angular from 'angular';
import template from './template.html';
import './style.scss';

export class TFTOptionItem {}

export const TFTOptionItemConfiguration = {
    template,
    controller: TFTOptionItem,
    bindings: {
        option: '<',
    },
    controllerAs: 'optionItemCtrl',
};

angular.module('TALENYA-FE').component('optionItem', TFTOptionItemConfiguration);
